import type { UseFormReturn } from 'react-hook-form';
import type { AxiosError } from 'axios';
import { showGenericError } from '@/lib/showGenericError.ts';

export function showFormError({
  hookForm,
  error,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hookForm: UseFormReturn<any>;
  error: unknown;
}) {
  const err = error as AxiosError;

  const status = err?.response?.status as number;
  const failedValidationsData = err?.response?.data as Record<
    string,
    unknown
  > | null;

  if (status !== 400 || !failedValidationsData) {
    return showGenericError(err);
  }

  const allFieldValues = hookForm.getValues();
  const registeredFieldNames = Object.keys(allFieldValues);

  for (const [field, fieldErrors] of Object.entries(failedValidationsData)) {
    if (registeredFieldNames.includes(field) && isStringArray(fieldErrors)) {
      const errorMessage = fieldErrors[0];
      hookForm.setError(field, {
        type: 'custom',
        message: errorMessage,
      });
    }
  }
}

function isStringArray(array: unknown): array is string[] {
  return (
    Array.isArray(array) &&
    !!array.length &&
    array.every((el) => typeof el === 'string')
  );
}
